import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../redux";
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import _ from 'lodash'
import { tableData,tableData1,tableData2,tableData3 } from './data'
import './index.scss'
import { scoreadjustlistHanndler,expertmuseumscoredetail } from "@/servers/goodsManageApi";
import { savaScore,savaScorenew } from "@/servers/storeManageApi";
import {withRouter} from "react-router-dom";
import {message, Modal, Radio, Select} from 'antd'
const { Option} = Select
@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.modalOk1 = this.modalOk1.bind(this);
    this.modalCancel1 = this.modalCancel1.bind(this);
    this.searchHandler = this.searchHandler.bind(this)
    this.resetHandler = this.resetHandler.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangelevel = this.onChangelevel.bind(this)
    this.onChangeName = this.onChangeName.bind(this)
    this.computedscore = this.computedscore.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    columns1: tableData1.tHead,
    dataSource1: tableData1.tBody,
    columns2: tableData2.tHead,
    dataSource2: tableData2.tBody,
    columns3: tableData3.tHead,
    dataSource3: tableData3.tBody,
    columns4: tableData3.tHead,
    dataSource4all:[],
    dataSource4: tableData3.tBody,
    cutdata:[],
    loading: true,
    loading1:true,
    loading2:true,
    loading3:true,
    loading4:true,
    level:0,
    modal: {
      visible: false,
    },
    modal1: {
      visible: false,
    },
    modal3: {
      visible: false,
    },
    modal4: {
      visible: false,
    },
    deleteid:'',
    annual: '',
    levelid: '',
    ownerlist:[],
    options:[],
    detaildata:[],
    museumname:'',
    detail:{}
  };


  searchHandler(){
    this.getListData1()
  }

  onChangeName(data){
    this.setState({
      museumname:data
    })
  }

  onChange(data){
    this.setState({
      annual:data
    },()=>{
      this.getListData('seconds')
    })
  }

  onChangelevel(data){
    this.setState({
      levelid:data
    })
  }

  resetHandler(){
    this.setState({
      annual:'',
      levelid: '',
      museumname:''
    },()=>{
      this.getListData()
    })

  }

  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false},
      dataSource1:[],
    })
  }

  modalCancel1(){
    this.setState({
      modal1: {...this.state.modal1, visible: false},
      dataSource2:[],
    })
  }

  modalOk(){
    const params =[]
    this.state.dataSource1.forEach(item=>{
      params.push({id:item.id,score:item.score})
    })
  }

  modalOk1(){
    let flag = false
    const params =[]
    for (let i=0;i<this.state.dataSource2.length;i++) {
      if (this.state.dataSource2[i].score != 0 && this.state.dataSource2[i].score !=='') {
        if (!(/(^[1-9]\d*$)/.test(this.state.dataSource2[i].score))) {
          message.error('输入的分值应为正整数');
          flag = true
          break
        }
        if (this.state.dataSource2[i].addorcut === '') {
          message.error('请选择加分或是减分');
          flag = true
          break
        }

      }
    }
    if (flag) {
      return false
    }
    this.state.dataSource2.forEach(item=>{
      if (item.addorcut === '0') {
        item.score = (-(item.score)).toString()
      }
      params.push({id:item.id,score:item.score})
    })
    savaScore(params).then(res=>{
      if (res.statecode === 0) {
        message.success('保存成功');
        this.modalCancel1()
        this.getListData()
        this.getListData1()
      } else {
        message.error('保存失败');
      }
    })
  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const params = {
      annual:this.state.annual,
    }
    scoreadjustlistHanndler(params).then(res=>{
      if (res.statecode === 0) {
        const arr = []
        res.records[0].annuallist.forEach(item=>{
          let obj = {}
          obj.name = item
          obj.value = item
          arr.push(obj)

        })
        this.setState({
          dataSource: res.records[0].scorelist,
          ownerlist: arr,
          loading:false
        });
      }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }
  getListData1(){
    this.setState({
      loading1: true
    });
    const params = {
      annual:this.state.annual,
      museumname:this.state.museumname
    }
    scoreadjustlistHanndler(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          modal: {...this.state.modal, visible: true},
        });
        setTimeout(()=>{
          this.setState({
          dataSource1: res.records[0].scorelist,
            loading1:false,
          });
        },500)
      }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }


  deleteHandler(data){
    const params = {
      museumid:data.museumid
    }
    expertmuseumscoredetail(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          modal4: {...this.state.modal4, visible: true,title:'评分详情:'+data.museumname}
        });
        setTimeout(()=>{
          this.setState({
            dataSource4:res.records,
            dataSource4all:res.records,
          })
        })
      }
    })
  }

  computeds(data){
    if (data.addorcut === '') {
      return ''
    } else {
      return data.addorcut === '0' ? '0':'1'
    }
  }

  computedinput(data){
    return data.score
  }

  onChangeInput(e,record){
    e.persist()
    if (e.target.value != 0 && e.target.value !=='') {
      if (!(/(^[1-9]\d*$)/.test(e.target.value))) {
        message.error('输入的分值应为正整数');
        e.target.value = 0
      }
    }
    const params = this.state.dataSource2
    params.forEach(item=>{
      if (item.id === record.id) {
        item.score = e.target.value
      }
    })
    this.setState({
      dataSource2:params
    })
  }

  onChangeScore(data,record){
    const params = this.state.dataSource2
    params.forEach(item=>{
      if (item.id === record.id) {
        item.addorcut = data.target.value
      }
    })
    this.setState({
      dataSource2:params
    })
  }

  adjustScore(data){
    this.setState({
      loading2: true
    });
    data.scoredetaillist.forEach(item=>{
      if (item.no === '1'){
        item.addorcut = '0'
        item.score = Math.abs(item.score)
      } else if (item.score.toString() === '0') {
        item.addorcut = ''
      } else {
        item.addorcut = '1'
      }
    })
    this.setState({
      modal1: {...this.state.modal1, visible: true},
    })
    setTimeout(()=>{
      this.setState({
        dataSource2:data.scoredetaillist,
        detail:data,
        loading2:false
      })
    },500)
  }

  computedscore(){
    const params =[]
    this.state.dataSource2.forEach(item=>{
      if (item.addorcut === '0') {
        item.score = (-(item.score)).toString()
      }
      params.push({id:item.id,score:item.score})
    })
    savaScorenew(params).then(res=>{
      if (res.statecode === 0) {
        console.log(res);
        this.setState({
          detail: {...this.state.detail, ranking: res.records[0].ranking},
        })
        this.getListData()
      } else {
        message.error(res.msg);
      }
    })
  }

  selectDtail(data){
    const params = {
      museumid:data
    }
    expertmuseumscoredetail(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          modal: {...this.state.modal, visible: true,title:'评分详情:'}
        });
        setTimeout(()=>{
          this.setState({
            dataSource1:res.records,
            dataSource1all:res.records,
          })
        })
      }
    })
  }

  getAlertSelect(data){
    const params = []
    this.state.dataSource4all.forEach(item=>{
      if (data === 4) {
        params.push(item)
      } else {
        if (Number(item.rank) <= Number(data)) {
          params.push(item)
        }
      }
    })
    this.setState({
      dataSource1: params
    })
  }

  computedScore(data){
    return Math.round((Number(data.score1)+Number(data.score2)+Number(data.score3))/3)
  }


  componentWillMount(){

  }

  computedData(data){
    let str= ''
    data.label1.forEach(item=>{
      str+=item+'</br>'
    })
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }
  computedData1(data){
    let str= ''
    data.label2.forEach(item=>{
      str+=item+'</br>'
    })
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }
  computedData2(data){
    let str= ''
    data.label3.forEach(item=>{
      str+=item+'</br>'
    })
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }
  createMarkup(str) {
    return {__html: str}
  }

  componentDidMount(){
    this.getListData();
  }

  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <Select
                  placeholder='请选择评估年度'
                  onChange={this.onChange}
                  style={{width:'160px'}}
              >
                {
                  this.state.ownerlist.map((item, index)=>{
                    return <Option key={index} value={item.value}>{item.name}</Option>
                  })
                }
              </Select>
              <CInput
                  value={this.state.museumname}
                  placeholder='请输入待调分博物馆名称'
                  onChange={this.onChangeName} />
              <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
              <CButton type='primary' onClick={this.resetHandler}>重置</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.deleteHandler(record)}>查看</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              visible={this.state.modal.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              closable={false}
              width={700}
          >
            <div className='detail-container' id="top" >
              <div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading1} columns={this.state.columns1} dataSource={this.state.dataSource1}>
                  <div
                      slot='index'
                      render={(text, record, index) => (
                          <div className='operate'>
                            {index+1}
                          </div>
                      )} />
                  <div
                      slot='operate'
                      render={(text, record, index) => (
                          <div className='operate'>
                            <CButton type='text' authId='goodsManageListEdit' onClick={() => this.adjustScore(record)}>调分</CButton>
                          </div>
                      )} />
                </CTable>
              </div>
            </div>
          </Modal>
          <Modal
              visible={this.state.modal1.visible}
              onOk={this.modalOk1}
              onCancel={this.modalCancel1}
              closable={false}
              width={700}
          >
            <div className='detail-container' id="top" >
              <div>
                <h3>{this.state.detail.museumname}/{this.state.annual}年 - 当前年度评估得分：{this.state.detail.addedscore}分</h3>
                <CTable ref='userManageList' checked={false} loading={this.state.loading2} columns={this.state.columns2} dataSource={this.state.dataSource2}>
                  <div
                      slot='index'
                      render={(text, record, index) => (
                          <div className='operate'>
                            {index+1}
                          </div>
                      )} />
                  <div
                      slot='operatecut'
                      render={(text, record, index) => (
                          <div className='operate'>
                            <Radio.Group onChange={(e) => this.onChangeScore(e,record)} value={this.computeds(record)}>
                              <Radio value='1'>加分</Radio>
                              <Radio value='0'>减分</Radio>
                            </Radio.Group>
                          </div>
                      )} />
                  <div
                      slot='operatenum'
                      render={(text, record, index) => (
                          <div className='operate'>
                            <CInput
                                value={this.computedinput(record)}
                                onChange={(e) => this.onChangeInput(e,record)}
                            ></CInput>
                          </div>
                      )} />
                </CTable>
                <div style={{display:'flex',alignItems:'center',marginTop:'20px'}}>
                  <CButton type='primary' onClick={() => this.computedscore()} style={{marginTop:'-20px'}}>重新算分</CButton>
                  <div style={{marginLeft:'20px'}}>
                    {this.state.detail.ranking}
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
              visible={this.state.modal3.visible}
              onOk={this.modalOk3}
              onCancel={this.modalCancel3}
              closable={false}
              width={700}
          >
            <div className='detail-container' id="top" >
              <div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading3} columns={this.state.columns3} dataSource={this.state.dataSource3}>
                  <div
                      slot='index'
                      render={(text, record, index) => (
                          <div className='operate'>
                            {index+1}
                          </div>
                      )} />
                </CTable>
              </div>
            </div>
          </Modal>
          <Modal
              title={this.state.modal4.title}
              visible={this.state.modal4.visible}
              onCancel={this.modalCancel4}
              width={860}
              footer={null}
          >
            <div>
              <div>
                指标项显示层级：
                <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(4)} style={{marginRight:'20px'}}>
                  全部
                </CButton>
                <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(3)} style={{marginRight:'20px'}}>
                  三级及以上
                </CButton>
                <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(2)} style={{marginRight:'20px'}}>
                  二级及以上
                </CButton>
              </div>
              <CTable ref='historyRecordDeleteUserList1' checked={false} loading={false} columns={this.state.columns4} dataSource={this.state.dataSource4}>
                <div
                    slot='index'
                    render={(text, record, index) => (
                        <div className='operate'>
                          {index+1}
                        </div>
                    )} />
                <div
                    slot='operate2019'
                    render={(text, record, index) => (
                        <div className='operate'>
                          <span>{this.computedData(record)}</span>
                        </div>
                    )} />
                <div
                    slot='operate2020'
                    render={(text, record, index) => (
                        <div className='operate'>
                          <span>{this.computedData1(record)}</span>
                        </div>
                    )} />
                <div
                    slot='operate2021'
                    render={(text, record, index) => (
                        <div className='operate'>
                          <span>{this.computedData2(record)}</span>
                        </div>
                    )} />
                <div
                    slot='index'
                    render={(text, record, index) => (
                        <div className='operate'>
                          {index+1}
                        </div>
                    )} />
                {/*<div*/}
                {/*    slot='pjf'*/}
                {/*    render={(text, record, index) => (*/}
                {/*        <div className='operate'>*/}
                {/*            {this.computedScore(record)}*/}
                {/*        </div>*/}
                {/*    )} />*/}
              </CTable>
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
